import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { KeyRound, Copy } from 'lucide-react';
import { OWNER, copyFresh, shareText } from './SharePicks';

// Owner-only (inside the PIN-locked tracker): today's access code for the shared picks link.
export default function DailyCodeBadge() {
  const [share, setShare] = useState(null);
  useEffect(() => {
    const load = () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sports-betting/board/share`, OWNER).then((r) => setShare(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const copy = async (make, msg) => {
    try { const d = await copyFresh(make); setShare(d); toast.success(msg(d)); } catch (_e) { toast.error('Copy failed'); }
  };

  if (!share?.code || !share?.token) return null;

  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-amber-500/50 bg-amber-500/10 px-2 py-1 text-xs text-amber-200" data-testid="daily-code-badge">
      <KeyRound className="w-3.5 h-3.5" />Today's code
      <button type="button" onClick={() => copy((d) => d.code, (d) => `Code ${d.code} copied`)} title="Copy today's code"
        className="font-mono font-bold tracking-[0.2em] text-amber-300 hover:text-amber-100" data-testid="daily-code-value">{share.code}</button>
      <button type="button" onClick={() => copy(shareText, (d) => `Copied link + "7-day code - ${d.code}" — paste into a text`)} title="Copy Nick's Picks link"
        className="ml-1 inline-flex items-center gap-1 rounded-md bg-amber-500 px-2 py-0.5 text-[11px] font-bold text-black hover:bg-amber-400" data-testid="daily-code-copy-link">
        <Copy className="w-3 h-3" />Link
      </button>
    </div>
  );
}
